import React, { useState } from "react";
import { Button } from "@/components/bnp-ui";
import ExportDialog from "./ExportDialog";
import { ExportFormat, ExportProgress } from "@/types/export";

interface ExportButtonProps {
  data: any[];
  filename?: string;
  onExport: (format: ExportFormat) => Promise<void>;
  progress: ExportProgress;
  disabled?: boolean;
  variant?: "primary" | "outline" | "danger";
  size?: "sm" | "md" | "lg";
  className?: string;
}

const ExportButton: React.FC<ExportButtonProps> = ({
  data,
  filename = "export",
  onExport,
  progress,
  disabled = false,
  variant = "outline",
  size = "md",
  className = "",
}) => {
  const [dialogOpened, setDialogOpened] = useState(false);

  const handleOpenDialog = () => {
    if (!disabled && data.length > 0) {
      setDialogOpened(true);
    }
  };

  const handleCloseDialog = () => {
    setDialogOpened(false);
  };

  const handleExport = async (format: ExportFormat) => {
    await onExport(format);
  };

  const isExporting =
    progress.status === "preparing" ||
    progress.status === "processing" ||
    progress.status === "downloading";

  const buttonDisabled = disabled || data.length === 0 || isExporting;

  return (
    <>
      <Button
        variant={variant}
        onClick={handleOpenDialog}
        disabled={buttonDisabled}
        className={className}
        style={{
          fontSize: size === "sm" ? "12px" : size === "lg" ? "16px" : "14px",
          padding:
            size === "sm"
              ? "6px 12px"
              : size === "lg"
                ? "12px 24px"
                : "8px 16px",
        }}
      >
        {isExporting ? "Exporting..." : "Export"}
      </Button>

      <ExportDialog
        opened={dialogOpened}
        onClose={handleCloseDialog}
        onExport={handleExport}
        progress={progress}
        totalRecords={data.length}
        loading={isExporting}
      />
    </>
  );
};

export default ExportButton;
